import { CustomMarkerBuilderI, ProcessMapSearchResponseStrategy } from 'src/app/interfaces/map.interface';
import { CustomMarker } from 'src/app/models/custom-marker.model';
import { MapMarker } from '../../map.enum';
import { Feature } from '../../map.interfaces';
import { CustomMarkerBuilderFactory } from '../builders/marker-creator.method';

export class CovidItemsProcessor implements ProcessMapSearchResponseStrategy {
  public constructor(private items: Feature[]) {}

  public getMarkers(): CustomMarker[] {
    const builder: CustomMarkerBuilderI = CustomMarkerBuilderFactory.getBuilder(MapMarker.COVID);
    return this.items.map((item: Feature) => {
      const [lon, lat] = item.geometry.coordinates;
      builder.setMarkerId({ lat, lon });
      builder.setCoords(lat, lon);
      builder.setRadius(item.properties.radius);
      builder.setInfoLabels(item.properties.labels);
      return builder.buildMarker();
    });
  }
}
